/**
 * Deep Wasteland — baked by ultra_map_editor. Edit via the editor.
 *
 * Do not hand-edit: this file is regenerated wholesale on the next bake, and
 * hand-written comments/formatting do not survive a bake.
 */
import type { WorldData } from '../../types';

export const map: WorldData = {
  cityName: "Deep Wasteland",
  ground: { width: 84, depth: 84 },
  spawnPoint: { x: 0, z: 36 },
  groundTexture: { textureUrl: "/textures/ground-realistic.webp", textureScale: 0.16, textureRotation: 0, secondaryUrl: "/textures/ground-stylized.webp", secondaryScale: 0.11, secondaryRotation: 0.82, noiseUrl: "/textures/noise-detailed.webp", noiseScale: 0.05, noiseRotation: -0.4, noiseOffset: -0.06, noiseGain: 0.9 },

  objects: [
    {
      id: "dw-plane",
      kind: "prop",
      label: "Crashed Beechcraft",
      position: { x: -8, z: -18 },
      size: { w: 10.5, d: 8.366, h: 2.591 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/objects/obj_plane-beechcraft-crash.glb",
      rotationY: 0.7,
    },
    {
      id: "dw-heli",
      kind: "prop",
      label: "Rusted Helicopter",
      position: { x: 20, z: 6 },
      size: { w: 9, d: 6.942, h: 3.662 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/objects/obj_heli-rusted.glb",
      rotationY: -0.9,
    },
    {
      id: "dw-farm",
      kind: "building",
      label: "Gutted Farmhouse",
      position: { x: -24, z: 8 },
      size: { w: 14.591, d: 9.326, h: 5 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_farm.glb",
      rotationY: 0.2,
    },
    {
      id: "dw-shack",
      kind: "building",
      label: "Squatter Shack",
      position: { x: 14, z: -26 },
      size: { w: 5.178, d: 7.183, h: 3.4 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_shack_a.glb",
      rotationY: 2.2,
    },
    {
      id: "dw-jet",
      kind: "prop",
      label: "Jet Engine",
      position: { x: -2, z: 6 },
      size: { w: 3.4, d: 2.546, h: 1.493 },
      color: 0x6a5c4a,
      interactable: true,
      lootObjectId: "raid_deep_wasteland:dw-jet",
      modelUrl: "/models/objects/obj_jet-engine.glb",
      rotationY: 1.3,
    },
    {
      id: "dw-well",
      kind: "prop",
      label: "Dry Well",
      position: { x: 26, z: 26 },
      size: { w: 2.164, d: 2.75, h: 1.6 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/objects/obj_well.glb",
      rotationY: 0,
    },
    {
      id: "deep_wasteland-row1-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -25.588, z: -11.115 },
      size: { w: 4.5, d: 1.919, h: 1.479 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.5,
      collisionD: 1.919,
      rotationY: 2.551,
    },
    {
      id: "deep_wasteland-row1-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -20.73, z: -8.328 },
      size: { w: 4.5, d: 1.906, h: 1.462 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.5,
      collisionD: 1.906,
      rotationY: 2.605,
    },
    {
      id: "deep_wasteland-row2-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 20.593, z: -14.163 },
      size: { w: 4.3, d: 1.834, h: 1.414 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.3,
      collisionD: 1.834,
      rotationY: 4.593,
    },
    {
      id: "deep_wasteland-row2-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 23.531, z: -13.729 },
      size: { w: 4.3, d: 1.821, h: 1.397 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.3,
      collisionD: 1.821,
      rotationY: 4.596,
    },
    {
      id: "deep_wasteland-row2-3",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 26.469, z: -13.878 },
      size: { w: 1.838, d: 4.3, h: 1.321 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.838,
      collisionD: 4.3,
      rotationY: 3.056,
    },
    {
      id: "deep_wasteland-row2-4",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 29.407, z: -13.97 },
      size: { w: 1.817, d: 4.3, h: 1.376 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-36.glb",
      collisionW: 1.817,
      collisionD: 4.3,
      rotationY: 3.157,
    },
    {
      id: "loot-1",
      kind: "loot",
      label: "Supply Crate",
      position: { x: 27.221, z: 13.204 },
      size: { w: 1.092, d: 1.092, h: 0.904 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_deep_wasteland:cache-1",
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 2.013,
    },
    {
      id: "loot-2",
      kind: "loot",
      label: "Stacked Crates",
      position: { x: 9.371, z: 27.109 },
      size: { w: 1.279, d: 1.218, h: 0.703 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_deep_wasteland:cache-2",
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 3.148,
    },
    {
      id: "loot-3",
      kind: "loot",
      label: "Ammo Case",
      position: { x: 14.411, z: -2.468 },
      size: { w: 1.33, d: 1.213, h: 0.793 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_deep_wasteland:cache-3",
      modelUrl: "/models/objects/obj_crates-2.glb",
      rotationY: 2.774,
    },
    {
      id: "loot-4",
      kind: "loot",
      label: "Dumped Barrel",
      position: { x: 12.302, z: 20.449 },
      size: { w: 1.115, d: 1.115, h: 1.497 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_deep_wasteland:cache-4",
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.489,
    },
    {
      id: "loot-5",
      kind: "loot",
      label: "Toolbox",
      position: { x: 12.7022, z: 7.1954 },
      size: { w: 0.791, d: 0.674, h: 0.623 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_deep_wasteland:cache-5",
      modelUrl: "/models/objects/obj_toolbox.glb",
      rotationY: 0.521,
    },
    {
      id: "loot-6",
      kind: "loot",
      label: "Supply Crate",
      position: { x: 26.497, z: -4.375 },
      size: { w: 1.051, d: 1.051, h: 0.871 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_deep_wasteland:cache-6",
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 5.124,
    },
    {
      id: "loot-7",
      kind: "loot",
      label: "Stacked Crates",
      position: { x: 27.272, z: -23.439 },
      size: { w: 1.372, d: 1.306, h: 0.754 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_deep_wasteland:cache-7",
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 0.87,
    },
    {
      id: "loot-8",
      kind: "loot",
      label: "Ammo Case",
      position: { x: 32.414, z: 8.808 },
      size: { w: 1.294, d: 1.18, h: 0.772 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_deep_wasteland:cache-8",
      modelUrl: "/models/objects/obj_crates-2.glb",
      rotationY: 5.754,
    },
    {
      id: "loot-9",
      kind: "loot",
      label: "Dumped Barrel",
      position: { x: -10.629, z: -3.685 },
      size: { w: 1.081, d: 1.081, h: 1.451 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_deep_wasteland:cache-9",
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.552,
    },
    {
      id: "loot-10",
      kind: "loot",
      label: "Toolbox",
      position: { x: -23.41, z: 19.303 },
      size: { w: 0.631, d: 0.537, h: 0.497 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_deep_wasteland:cache-10",
      modelUrl: "/models/objects/obj_toolbox.glb",
      rotationY: 2.645,
    },
    {
      id: "loot-11",
      kind: "loot",
      label: "Supply Crate",
      position: { x: -32.9365, z: 2.8811 },
      size: { w: 1.216, d: 1.216, h: 1.008 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_deep_wasteland:cache-11",
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 2.858,
    },
    {
      id: "loot-12",
      kind: "loot",
      label: "Stacked Crates",
      position: { x: -33.5387, z: 5.6709 },
      size: { w: 1.348, d: 1.283, h: 0.741 },
      color: 0x7a6544,
      interactable: true,
      lootObjectId: "raid_deep_wasteland:cache-12",
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 2.874,
    },
    {
      id: "deep_wasteland-junk-1",
      kind: "prop",
      label: "Wire Fence",
      position: { x: 5.724, z: -20.761 },
      size: { w: 2.394, d: 0.12, h: 2.287 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 5.546,
    },
    {
      id: "deep_wasteland-junk-2",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 32.132, z: 13.538 },
      size: { w: 0.751, d: 0.948, h: 1.079 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 2.451,
    },
    {
      id: "deep_wasteland-junk-4",
      kind: "prop",
      label: "Barrel",
      position: { x: 34.509, z: -6.84 },
      size: { w: 0.726, d: 0.726, h: 0.974 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.455,
    },
    {
      id: "deep_wasteland-junk-5",
      kind: "prop",
      label: "Wire Fence",
      position: { x: 34.03, z: 4.156 },
      size: { w: 2.748, d: 0.137, h: 2.625 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 5.436,
    },
    {
      id: "deep_wasteland-junk-6",
      kind: "prop",
      label: "Stump",
      position: { x: -3.375, z: -32.67 },
      size: { w: 0.624, d: 0.608, h: 0.683 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 0.912,
    },
    {
      id: "deep_wasteland-junk-7",
      kind: "prop",
      label: "Utility Post",
      position: { x: -35.769, z: 7.532 },
      size: { w: 1.525, d: 2.122, h: 4.428 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 1.449,
    },
    {
      id: "deep_wasteland-junk-8",
      kind: "prop",
      label: "Sandbags",
      position: { x: 6.161, z: 10.931 },
      size: { w: 2.11, d: 0.306, h: 0.287 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 2.112,
    },
    {
      id: "deep_wasteland-junk-9",
      kind: "prop",
      label: "Broken Tree",
      position: { x: 22.166, z: -28.323 },
      size: { w: 7.326, d: 2.895, h: 3.081 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-2.glb",
      rotationY: 1.164,
    },
    {
      id: "deep_wasteland-junk-10",
      kind: "prop",
      label: "Barrel",
      position: { x: 31.598, z: 3.515 },
      size: { w: 0.676, d: 0.676, h: 0.908 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.701,
    },
    {
      id: "deep_wasteland-junk-11",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -1.181, z: 17.695 },
      size: { w: 0.789, d: 0.995, h: 1.133 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 0.077,
    },
    {
      id: "deep_wasteland-junk-12",
      kind: "prop",
      label: "Barrel",
      position: { x: -2.757, z: -15.126 },
      size: { w: 0.817, d: 0.817, h: 1.096 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.802,
    },
    {
      id: "deep_wasteland-junk-13",
      kind: "prop",
      label: "Barrel",
      position: { x: 10.773, z: 27.54 },
      size: { w: 0.719, d: 0.719, h: 0.966 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.628,
    },
    {
      id: "deep_wasteland-junk-14",
      kind: "prop",
      label: "Tarp",
      position: { x: -23.749, z: -6.391 },
      size: { w: 1.459, d: 1.255, h: 0.433 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 2.116,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-15",
      kind: "prop",
      label: "Tarp",
      position: { x: -1.333, z: -30.344 },
      size: { w: 1.284, d: 1.104, h: 0.381 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 3.56,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-16",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 26.361, z: 11.314 },
      size: { w: 0.635, d: 0.802, h: 0.912 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 0.352,
    },
    {
      id: "deep_wasteland-junk-17",
      kind: "prop",
      label: "Stump",
      position: { x: 9.87, z: 19.308 },
      size: { w: 0.601, d: 0.586, h: 0.658 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 4.255,
    },
    {
      id: "deep_wasteland-junk-18",
      kind: "prop",
      label: "Broken Tree",
      position: { x: -4.541, z: 20.182 },
      size: { w: 5.502, d: 3.266, h: 3.33 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      rotationY: 2.813,
    },
    {
      id: "deep_wasteland-junk-19",
      kind: "prop",
      label: "Stump",
      position: { x: 23.399, z: 26.057 },
      size: { w: 0.764, d: 0.745, h: 0.837 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 5.504,
    },
    {
      id: "deep_wasteland-junk-20",
      kind: "prop",
      label: "Sandbags",
      position: { x: 33.943, z: 6.903 },
      size: { w: 2.091, d: 0.303, h: 0.285 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 2.091,
    },
    {
      id: "deep_wasteland-junk-21",
      kind: "prop",
      label: "Tarp",
      position: { x: -29.313, z: -10.055 },
      size: { w: 1.645, d: 1.414, h: 0.488 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 2.906,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-22",
      kind: "prop",
      label: "Broken Tree",
      position: { x: -9.297, z: -31.748 },
      size: { w: 7.71, d: 3.047, h: 3.243 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-2.glb",
      rotationY: 4.899,
    },
    {
      id: "deep_wasteland-junk-23",
      kind: "prop",
      label: "Stump",
      position: { x: -4.541, z: 7.565 },
      size: { w: 0.752, d: 0.734, h: 0.824 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 4.838,
    },
    {
      id: "deep_wasteland-junk-24",
      kind: "prop",
      label: "Utility Post",
      position: { x: -3.787, z: -12.207 },
      size: { w: 1.544, d: 2.149, h: 4.483 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 3.25,
    },
    {
      id: "deep_wasteland-junk-25",
      kind: "prop",
      label: "Barrel",
      position: { x: 19.171, z: -2.747 },
      size: { w: 0.666, d: 0.666, h: 0.894 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.857,
    },
    {
      id: "deep_wasteland-junk-26",
      kind: "prop",
      label: "Wire Fence",
      position: { x: 1.963, z: -27.659 },
      size: { w: 2.871, d: 0.144, h: 2.743 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 0.195,
    },
    {
      id: "deep_wasteland-junk-27",
      kind: "prop",
      label: "Barrel",
      position: { x: -3.135, z: -22.435 },
      size: { w: 0.708, d: 0.708, h: 0.95 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.694,
    },
    {
      id: "deep_wasteland-junk-28",
      kind: "prop",
      label: "Stump",
      position: { x: 4.735, z: -35.232 },
      size: { w: 0.631, d: 0.615, h: 0.691 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 2.243,
    },
    {
      id: "deep_wasteland-junk-29",
      kind: "prop",
      label: "Wire Fence",
      position: { x: 7.084, z: -36.061 },
      size: { w: 2.225, d: 0.111, h: 2.126 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 3.808,
    },
    {
      id: "deep_wasteland-junk-30",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 14.151, z: -5.41 },
      size: { w: 2.086, d: 1.884, h: 0.883 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 2.618,
    },
    {
      id: "deep_wasteland-junk-31",
      kind: "prop",
      label: "Barrel",
      position: { x: 7.749, z: -34.556 },
      size: { w: 0.686, d: 0.686, h: 0.92 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.328,
    },
    {
      id: "deep_wasteland-junk-32",
      kind: "prop",
      label: "Sandbags",
      position: { x: 7.566, z: -13.178 },
      size: { w: 1.486, d: 0.216, h: 0.203 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 1.558,
    },
    {
      id: "deep_wasteland-junk-33",
      kind: "prop",
      label: "Sandbags",
      position: { x: 6.657, z: -29.71 },
      size: { w: 1.569, d: 0.228, h: 0.214 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 6.043,
    },
    {
      id: "deep_wasteland-junk-34",
      kind: "prop",
      label: "Utility Post",
      position: { x: 8.44, z: 34.46 },
      size: { w: 1.702, d: 2.368, h: 4.942 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 4.582,
    },
    {
      id: "deep_wasteland-junk-35",
      kind: "prop",
      label: "Barrel",
      position: { x: 17.354, z: -21.197 },
      size: { w: 0.667, d: 0.667, h: 0.895 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 6.219,
    },
    {
      id: "deep_wasteland-junk-36",
      kind: "prop",
      label: "Tarp",
      position: { x: 6.34, z: 28.852 },
      size: { w: 1.429, d: 1.229, h: 0.424 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 3.08,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-37",
      kind: "prop",
      label: "Barrel",
      position: { x: -3.129, z: 25.55 },
      size: { w: 0.791, d: 0.791, h: 1.062 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.841,
    },
    {
      id: "deep_wasteland-junk-38",
      kind: "prop",
      label: "Barrel",
      position: { x: 4.341, z: -32.767 },
      size: { w: 0.77, d: 0.77, h: 1.034 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.392,
    },
    {
      id: "deep_wasteland-junk-39",
      kind: "prop",
      label: "Sandbags",
      position: { x: 32.327, z: -16.588 },
      size: { w: 2.025, d: 0.294, h: 0.276 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 3.612,
    },
    {
      id: "deep_wasteland-junk-40",
      kind: "prop",
      label: "Broken Tree",
      position: { x: 3.461, z: 24.268 },
      size: { w: 8.135, d: 3.215, h: 3.422 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-2.glb",
      rotationY: 0.713,
    },
    {
      id: "deep_wasteland-junk-41",
      kind: "prop",
      label: "Barrel",
      position: { x: 3.93, z: -16.39 },
      size: { w: 0.707, d: 0.707, h: 0.949 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.154,
    },
    {
      id: "deep_wasteland-junk-42",
      kind: "prop",
      label: "Sandbags",
      position: { x: 27.563, z: -9.318 },
      size: { w: 1.927, d: 0.28, h: 0.263 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 3.754,
    },
    {
      id: "deep_wasteland-junk-43",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -31.616, z: 18.012 },
      size: { w: 2.251, d: 2.033, h: 0.953 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 0.524,
    },
    {
      id: "deep_wasteland-junk-44",
      kind: "prop",
      label: "Stump",
      position: { x: -17.02, z: -30.669 },
      size: { w: 0.601, d: 0.586, h: 0.658 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 1.687,
    },
    {
      id: "deep_wasteland-junk-45",
      kind: "prop",
      label: "Tarp",
      position: { x: -36.795, z: 2.947 },
      size: { w: 1.633, d: 1.405, h: 0.485 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 5.282,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-46",
      kind: "prop",
      label: "Barrel",
      position: { x: -10.832, z: 30.762 },
      size: { w: 0.76, d: 0.76, h: 1.02 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 6.239,
    },
    {
      id: "deep_wasteland-junk-47",
      kind: "prop",
      label: "Tarp",
      position: { x: -29.633, z: -18.222 },
      size: { w: 1.186, d: 1.02, h: 0.352 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 0.019,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-48",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -11.12, z: 19.223 },
      size: { w: 2.781, d: 0.139, h: 2.657 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 1.104,
    },
    {
      id: "deep_wasteland-junk-49",
      kind: "prop",
      label: "Broken Tree",
      position: { x: 17.817, z: 20.194 },
      size: { w: 4.767, d: 2.83, h: 2.886 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      rotationY: 5.102,
    },
    {
      id: "deep_wasteland-junk-50",
      kind: "prop",
      label: "Tarp",
      position: { x: 4.904, z: -36.319 },
      size: { w: 1.302, d: 1.119, h: 0.386 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 6.004,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-51",
      kind: "prop",
      label: "Stump",
      position: { x: 1.567, z: 16.421 },
      size: { w: 0.676, d: 0.66, h: 0.741 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 1.269,
    },
    {
      id: "deep_wasteland-junk-52",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 13.703, z: 33.042 },
      size: { w: 0.619, d: 0.782, h: 0.889 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 1.936,
    },
    {
      id: "deep_wasteland-junk-53",
      kind: "prop",
      label: "Tarp",
      position: { x: -12.366, z: -23.018 },
      size: { w: 1.252, d: 1.077, h: 0.372 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 0.488,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-54",
      kind: "prop",
      label: "Sandbags",
      position: { x: -0.651, z: -16.981 },
      size: { w: 1.684, d: 0.244, h: 0.23 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 1.546,
    },
    {
      id: "deep_wasteland-junk-55",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 8.347, z: -27.272 },
      size: { w: 0.635, d: 0.802, h: 0.912 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 2.007,
    },
    {
      id: "deep_wasteland-junk-56",
      kind: "prop",
      label: "Barrel",
      position: { x: -28.192, z: -7.33 },
      size: { w: 0.759, d: 0.759, h: 1.018 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.076,
    },
    {
      id: "deep_wasteland-junk-57",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -11.048, z: 34.57 },
      size: { w: 2.133, d: 0.107, h: 2.038 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 4.368,
    },
    {
      id: "deep_wasteland-junk-58",
      kind: "prop",
      label: "Stump",
      position: { x: 26.115, z: 13.461 },
      size: { w: 0.667, d: 0.65, h: 0.73 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 5.186,
    },
    {
      id: "deep_wasteland-junk-59",
      kind: "prop",
      label: "Stump",
      position: { x: 28.419, z: 3.177 },
      size: { w: 0.844, d: 0.823, h: 0.924 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 0.256,
    },
    {
      id: "deep_wasteland-junk-60",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -33.49, z: -15.078 },
      size: { w: 2.072, d: 1.872, h: 0.878 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 1.453,
    },
    {
      id: "deep_wasteland-junk-61",
      kind: "prop",
      label: "Barrel",
      position: { x: -3.1, z: 24.146 },
      size: { w: 0.606, d: 0.606, h: 0.814 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.699,
    },
    {
      id: "deep_wasteland-junk-62",
      kind: "prop",
      label: "Stump",
      position: { x: -19.534, z: 28.574 },
      size: { w: 0.675, d: 0.658, h: 0.739 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 1.448,
    },
    {
      id: "deep_wasteland-junk-63",
      kind: "prop",
      label: "Stump",
      position: { x: 8.391, z: 14.915 },
      size: { w: 0.824, d: 0.804, h: 0.902 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 4.576,
    },
    {
      id: "deep_wasteland-junk-64",
      kind: "prop",
      label: "Stump",
      position: { x: -2.986, z: 9.183 },
      size: { w: 0.7, d: 0.683, h: 0.766 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 2.675,
    },
    {
      id: "deep_wasteland-junk-65",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -25.073, z: 27.107 },
      size: { w: 2.248, d: 2.031, h: 0.952 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 3.108,
    },
    {
      id: "deep_wasteland-junk-66",
      kind: "prop",
      label: "Tarp",
      position: { x: -8.619, z: 16.575 },
      size: { w: 1.651, d: 1.42, h: 0.49 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 3.759,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-67",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 33.382, z: 11.777 },
      size: { w: 0.7, d: 0.884, h: 1.005 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 5.712,
    },
    {
      id: "deep_wasteland-junk-68",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -7.958, z: 30.162 },
      size: { w: 0.655, d: 0.827, h: 0.941 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 2.575,
    },
    {
      id: "deep_wasteland-junk-69",
      kind: "prop",
      label: "Utility Post",
      position: { x: -7.395, z: -0.434 },
      size: { w: 1.264, d: 1.758, h: 3.669 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 4.09,
    },
    {
      id: "deep_wasteland-junk-70",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 10.501, z: -22.534 },
      size: { w: 0.778, d: 0.983, h: 1.118 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 3.397,
    },
    {
      id: "deep_wasteland-junk-71",
      kind: "prop",
      label: "Barrel",
      position: { x: 13.23, z: 24.977 },
      size: { w: 0.707, d: 0.707, h: 0.949 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.758,
    },
    {
      id: "deep_wasteland-junk-72",
      kind: "prop",
      label: "Stump",
      position: { x: -4.767, z: -28.402 },
      size: { w: 0.766, d: 0.747, h: 0.839 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 4.626,
    },
    {
      id: "deep_wasteland-junk-73",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 30.841, z: -8.133 },
      size: { w: 0.709, d: 0.895, h: 1.019 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 3.45,
    },
    {
      id: "deep_wasteland-junk-74",
      kind: "prop",
      label: "Stump",
      position: { x: 23.035, z: 23.329 },
      size: { w: 0.639, d: 0.624, h: 0.7 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 5.965,
    },
    {
      id: "deep_wasteland-junk-75",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 9.517, z: -22.787 },
      size: { w: 0.776, d: 0.979, h: 1.114 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 1.904,
    },
    {
      id: "deep_wasteland-junk-76",
      kind: "prop",
      label: "Barrel",
      position: { x: -21.972, z: -5.284 },
      size: { w: 0.663, d: 0.663, h: 0.89 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.894,
    },
    {
      id: "deep_wasteland-junk-77",
      kind: "prop",
      label: "Stump",
      position: { x: 9.153, z: 12.588 },
      size: { w: 0.677, d: 0.66, h: 0.741 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 6.193,
    },
    {
      id: "deep_wasteland-junk-78",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -0.184, z: 14.853 },
      size: { w: 1.93, d: 1.744, h: 0.818 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 5.573,
    },
    {
      id: "deep_wasteland-junk-79",
      kind: "prop",
      label: "Tarp",
      position: { x: -21.777, z: 29.084 },
      size: { w: 1.302, d: 1.12, h: 0.386 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 0.121,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-80",
      kind: "prop",
      label: "Sandbags",
      position: { x: -22.639, z: -12.411 },
      size: { w: 1.769, d: 0.257, h: 0.241 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 1.006,
    },
    {
      id: "deep_wasteland-junk-81",
      kind: "prop",
      label: "Tarp",
      position: { x: -20.518, z: 25.164 },
      size: { w: 1.462, d: 1.257, h: 0.434 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 6.226,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-82",
      kind: "prop",
      label: "Barrel",
      position: { x: -33.499, z: 9.674 },
      size: { w: 0.584, d: 0.584, h: 0.784 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.112,
    },
    {
      id: "deep_wasteland-junk-83",
      kind: "prop",
      label: "Utility Post",
      position: { x: -6.55, z: -9.282 },
      size: { w: 1.481, d: 2.06, h: 4.299 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 4.937,
    },
    {
      id: "deep_wasteland-junk-84",
      kind: "prop",
      label: "Stump",
      position: { x: -4.693, z: 14.691 },
      size: { w: 0.652, d: 0.636, h: 0.714 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 4.808,
    },
    {
      id: "deep_wasteland-junk-85",
      kind: "prop",
      label: "Stump",
      position: { x: 15.02, z: 18.279 },
      size: { w: 0.704, d: 0.687, h: 0.771 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 5.55,
    },
    {
      id: "deep_wasteland-junk-86",
      kind: "prop",
      label: "Broken Tree",
      position: { x: -11.799, z: 24.556 },
      size: { w: 6.165, d: 3.659, h: 3.732 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      rotationY: 1.812,
    },
    {
      id: "deep_wasteland-junk-87",
      kind: "prop",
      label: "Broken Tree",
      position: { x: 35.763, z: -9.3 },
      size: { w: 4.643, d: 2.756, h: 2.811 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      rotationY: 2.14,
    },
    {
      id: "deep_wasteland-junk-88",
      kind: "prop",
      label: "Barrel",
      position: { x: -5.174, z: -34.397 },
      size: { w: 0.803, d: 0.803, h: 1.078 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.269,
    },
    {
      id: "deep_wasteland-junk-89",
      kind: "prop",
      label: "Wire Fence",
      position: { x: 7.304, z: -15.36 },
      size: { w: 2.526, d: 0.126, h: 2.413 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 4.503,
    },
    {
      id: "deep_wasteland-junk-90",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 15.871, z: 25.236 },
      size: { w: 0.725, d: 0.915, h: 1.041 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 4.327,
    },
    {
      id: "deep_wasteland-junk-91",
      kind: "prop",
      label: "Stump",
      position: { x: -4.851, z: -32.459 },
      size: { w: 0.852, d: 0.831, h: 0.933 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 2.61,
    },
    {
      id: "deep_wasteland-junk-92",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 36.213, z: 1.405 },
      size: { w: 0.601, d: 0.759, h: 0.863 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 1.678,
    },
    {
      id: "deep_wasteland-junk-93",
      kind: "prop",
      label: "Stump",
      position: { x: 5.764, z: -25.756 },
      size: { w: 0.77, d: 0.751, h: 0.843 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 6.064,
    },
    {
      id: "deep_wasteland-junk-94",
      kind: "prop",
      label: "Broken Tree",
      position: { x: 0.029, z: -12.807 },
      size: { w: 5.06, d: 3.003, h: 3.063 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      rotationY: 1.088,
    },
    {
      id: "deep_wasteland-junk-95",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -27.426, z: -5.676 },
      size: { w: 1.974, d: 1.783, h: 0.836 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 6.115,
    },
    {
      id: "deep_wasteland-junk-96",
      kind: "prop",
      label: "Barrel",
      position: { x: -0.952, z: -22.966 },
      size: { w: 0.716, d: 0.716, h: 0.961 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.684,
    },
    {
      id: "deep_wasteland-junk-97",
      kind: "prop",
      label: "Sandbags",
      position: { x: 10.566, z: -14.72 },
      size: { w: 1.597, d: 0.232, h: 0.218 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 2.337,
    },
    {
      id: "deep_wasteland-junk-98",
      kind: "prop",
      label: "Utility Post",
      position: { x: 17.589, z: -1.035 },
      size: { w: 1.263, d: 1.757, h: 3.666 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 2.747,
    },
    {
      id: "deep_wasteland-junk-99",
      kind: "prop",
      label: "Tarp",
      position: { x: 11.936, z: 28.221 },
      size: { w: 1.263, d: 1.087, h: 0.375 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 4.735,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-100",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -5.341, z: 23.68 },
      size: { w: 0.653, d: 0.824, h: 0.938 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 4.685,
    },
    {
      id: "deep_wasteland-junk-101",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -19.122, z: 31.268 },
      size: { w: 2.993, d: 0.15, h: 2.859 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 3.553,
    },
    {
      id: "deep_wasteland-junk-102",
      kind: "prop",
      label: "Tarp",
      position: { x: -17.994, z: 0.981 },
      size: { w: 1.409, d: 1.212, h: 0.418 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 4.617,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-103",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -14.537, z: -26.538 },
      size: { w: 2.881, d: 0.144, h: 2.752 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 1.394,
    },
    {
      id: "deep_wasteland-junk-104",
      kind: "prop",
      label: "Wire Fence",
      position: { x: 36.699, z: -1.69 },
      size: { w: 3.025, d: 0.151, h: 2.89 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 5.289,
    },
    {
      id: "deep_wasteland-junk-105",
      kind: "prop",
      label: "Sandbags",
      position: { x: -36.737, z: -1.279 },
      size: { w: 1.816, d: 0.263, h: 0.247 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 2.357,
    },
    {
      id: "deep_wasteland-junk-106",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -20.957, z: -23.081 },
      size: { w: 2.216, d: 0.111, h: 2.117 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 4.228,
    },
    {
      id: "deep_wasteland-junk-107",
      kind: "prop",
      label: "Utility Post",
      position: { x: 8.072, z: 17.915 },
      size: { w: 1.257, d: 1.749, h: 3.649 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 0.821,
    },
    {
      id: "deep_wasteland-junk-108",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -17.476, z: -23.811 },
      size: { w: 0.775, d: 0.979, h: 1.114 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 5.908,
    },
    {
      id: "deep_wasteland-junk-109",
      kind: "prop",
      label: "Tarp",
      position: { x: 27.197, z: 0.039 },
      size: { w: 1.582, d: 1.361, h: 0.47 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 1.323,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-110",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -0.544, z: -32.079 },
      size: { w: 1.99, d: 1.798, h: 0.843 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 6,
    },
    {
      id: "deep_wasteland-junk-111",
      kind: "prop",
      label: "Utility Post",
      position: { x: -8.251, z: 11.811 },
      size: { w: 1.373, d: 1.91, h: 3.985 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 2.671,
    },
    {
      id: "deep_wasteland-junk-112",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 4.344, z: -27.864 },
      size: { w: 0.627, d: 0.791, h: 0.901 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 1.857,
    },
    {
      id: "deep_wasteland-junk-113",
      kind: "prop",
      label: "Broken Tree",
      position: { x: 19.739, z: -7.777 },
      size: { w: 5.332, d: 3.165, h: 3.228 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      rotationY: 5.698,
    },
    {
      id: "deep_wasteland-junk-114",
      kind: "prop",
      label: "Stump",
      position: { x: 28.642, z: 15.537 },
      size: { w: 0.666, d: 0.65, h: 0.729 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 5.835,
    },
    {
      id: "deep_wasteland-junk-115",
      kind: "prop",
      label: "Broken Tree",
      position: { x: -17.369, z: -2.135 },
      size: { w: 4.908, d: 2.914, h: 2.971 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      rotationY: 1.083,
    },
    {
      id: "deep_wasteland-junk-116",
      kind: "prop",
      label: "Sandbags",
      position: { x: -17.154, z: -18.335 },
      size: { w: 1.661, d: 0.241, h: 0.226 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 2.114,
    },
    {
      id: "deep_wasteland-junk-117",
      kind: "prop",
      label: "Sandbags",
      position: { x: -23.491, z: -23.535 },
      size: { w: 1.723, d: 0.25, h: 0.235 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 2.372,
    },
    {
      id: "deep_wasteland-junk-118",
      kind: "prop",
      label: "Stump",
      position: { x: 4.192, z: 31.123 },
      size: { w: 0.759, d: 0.741, h: 0.831 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 0.146,
    },
    {
      id: "deep_wasteland-junk-119",
      kind: "prop",
      label: "Stump",
      position: { x: -28.664, z: -3.372 },
      size: { w: 0.76, d: 0.741, h: 0.832 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 0.691,
    },
    {
      id: "deep_wasteland-junk-120",
      kind: "prop",
      label: "Broken Tree",
      position: { x: -34.028, z: -5.402 },
      size: { w: 6.174, d: 3.665, h: 3.737 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      rotationY: 5.082,
    },
    {
      id: "deep_wasteland-junk-121",
      kind: "prop",
      label: "Stump",
      position: { x: 16.414, z: -5.662 },
      size: { w: 0.638, d: 0.623, h: 0.699 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 0.97,
    },
    {
      id: "deep_wasteland-junk-122",
      kind: "prop",
      label: "Broken Tree",
      position: { x: -26.293, z: -25.895 },
      size: { w: 4.728, d: 2.807, h: 2.862 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      rotationY: 6.031,
    },
    {
      id: "deep_wasteland-junk-123",
      kind: "prop",
      label: "Stump",
      position: { x: 20.904, z: 29.601 },
      size: { w: 0.63, d: 0.614, h: 0.69 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 3.419,
    },
    {
      id: "deep_wasteland-junk-124",
      kind: "prop",
      label: "Tarp",
      position: { x: 8.004, z: 11.089 },
      size: { w: 1.205, d: 1.036, h: 0.358 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 2.848,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-125",
      kind: "prop",
      label: "Barrel",
      position: { x: -5.115, z: -26.546 },
      size: { w: 0.611, d: 0.611, h: 0.82 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.431,
    },
    {
      id: "deep_wasteland-junk-126",
      kind: "prop",
      label: "Stump",
      position: { x: 14.127, z: 25.409 },
      size: { w: 0.673, d: 0.657, h: 0.737 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 4.639,
    },
    {
      id: "deep_wasteland-junk-127",
      kind: "prop",
      label: "Stump",
      position: { x: -17.317, z: 3.667 },
      size: { w: 0.621, d: 0.606, h: 0.68 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 4.545,
    },
    {
      id: "deep_wasteland-junk-128",
      kind: "prop",
      label: "Tarp",
      position: { x: -18.767, z: -23.047 },
      size: { w: 1.337, d: 1.149, h: 0.397 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 4.772,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-129",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -14.922, z: 4.329 },
      size: { w: 3.036, d: 0.152, h: 2.9 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 2.448,
    },
    {
      id: "deep_wasteland-junk-130",
      kind: "prop",
      label: "Stump",
      position: { x: 24.442, z: 12.028 },
      size: { w: 0.835, d: 0.815, h: 0.915 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 5.947,
    },
    {
      id: "deep_wasteland-junk-131",
      kind: "prop",
      label: "Sandbags",
      position: { x: -32.63, z: 8.106 },
      size: { w: 1.866, d: 0.271, h: 0.254 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 6.224,
    },
    {
      id: "deep_wasteland-junk-132",
      kind: "prop",
      label: "Stump",
      position: { x: 27.371, z: 16.149 },
      size: { w: 0.676, d: 0.66, h: 0.74 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 1.114,
    },
    {
      id: "deep_wasteland-junk-133",
      kind: "prop",
      label: "Tarp",
      position: { x: -3.145, z: 11.572 },
      size: { w: 1.176, d: 1.012, h: 0.349 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 5.388,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-134",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -23.637, z: -2.625 },
      size: { w: 2.947, d: 0.147, h: 2.815 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 4.303,
    },
    {
      id: "deep_wasteland-junk-135",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 14.349, z: 31.077 },
      size: { w: 0.575, d: 0.726, h: 0.826 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 0.931,
    },
    {
      id: "deep_wasteland-junk-136",
      kind: "prop",
      label: "Stump",
      position: { x: -21.734, z: -0.045 },
      size: { w: 0.763, d: 0.744, h: 0.835 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 3.794,
    },
    {
      id: "deep_wasteland-junk-137",
      kind: "prop",
      label: "Barrel",
      position: { x: 13.568, z: -21.572 },
      size: { w: 0.801, d: 0.801, h: 1.076 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.171,
    },
    {
      id: "deep_wasteland-junk-138",
      kind: "prop",
      label: "Stump",
      position: { x: -5.89, z: 28.076 },
      size: { w: 0.656, d: 0.64, h: 0.718 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 2.757,
    },
    {
      id: "deep_wasteland-junk-139",
      kind: "prop",
      label: "Stump",
      position: { x: -1.613, z: 28.417 },
      size: { w: 0.713, d: 0.696, h: 0.781 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 0.079,
    },
    {
      id: "deep_wasteland-junk-140",
      kind: "prop",
      label: "Stump",
      position: { x: -13.113, z: -3.955 },
      size: { w: 0.704, d: 0.686, h: 0.771 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 3.253,
    },
    {
      id: "deep_wasteland-junk-141",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 30.685, z: 6.092 },
      size: { w: 2.07, d: 1.87, h: 0.877 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 3.08,
    },
    {
      id: "deep_wasteland-junk-142",
      kind: "prop",
      label: "Broken Tree",
      position: { x: 0.782, z: -36.536 },
      size: { w: 5.392, d: 3.201, h: 3.264 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      rotationY: 1.433,
    },
    {
      id: "deep_wasteland-junk-143",
      kind: "prop",
      label: "Stump",
      position: { x: -16.989, z: -6.302 },
      size: { w: 0.603, d: 0.589, h: 0.661 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 0.164,
    },
    {
      id: "deep_wasteland-junk-144",
      kind: "prop",
      label: "Stump",
      position: { x: -15.682, z: 28.133 },
      size: { w: 0.667, d: 0.651, h: 0.731 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 0.787,
    },
    {
      id: "deep_wasteland-junk-145",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 24.948, z: 8.075 },
      size: { w: 0.655, d: 0.826, h: 0.94 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 2.155,
    },
    {
      id: "deep_wasteland-junk-146",
      kind: "prop",
      label: "Tarp",
      position: { x: 24.195, z: -9.221 },
      size: { w: 1.645, d: 1.415, h: 0.488 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 0.895,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-147",
      kind: "prop",
      label: "Utility Post",
      position: { x: 3.052, z: 11.359 },
      size: { w: 1.304, d: 1.815, h: 3.787 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 1.26,
    },
    {
      id: "deep_wasteland-junk-148",
      kind: "prop",
      label: "Sandbags",
      position: { x: -1.302, z: 12.584 },
      size: { w: 1.879, d: 0.273, h: 0.256 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 0.815,
    },
    {
      id: "deep_wasteland-junk-149",
      kind: "prop",
      label: "Sandbags",
      position: { x: 32.379, z: 0.53 },
      size: { w: 1.773, d: 0.257, h: 0.242 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 4.266,
    },
    {
      id: "deep_wasteland-junk-150",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -22.626, z: -28.596 },
      size: { w: 2.53, d: 0.127, h: 2.417 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 0.555,
    },
    {
      id: "deep_wasteland-junk-151",
      kind: "prop",
      label: "Barrel",
      position: { x: 23.355, z: 12.957 },
      size: { w: 0.614, d: 0.614, h: 0.824 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.028,
    },
    {
      id: "deep_wasteland-junk-152",
      kind: "prop",
      label: "Barrel",
      position: { x: -3.75, z: -28.832 },
      size: { w: 0.659, d: 0.659, h: 0.885 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.361,
    },
    {
      id: "deep_wasteland-junk-153",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 10.184, z: 24.243 },
      size: { w: 2.265, d: 2.046, h: 0.959 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 1.604,
    },
    {
      id: "deep_wasteland-junk-154",
      kind: "prop",
      label: "Stump",
      position: { x: -2.036, z: -16.627 },
      size: { w: 0.74, d: 0.722, h: 0.81 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 6.139,
    },
    {
      id: "deep_wasteland-junk-155",
      kind: "prop",
      label: "Utility Post",
      position: { x: 10.193, z: -19.646 },
      size: { w: 1.486, d: 2.068, h: 4.315 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 5.155,
    },
    {
      id: "deep_wasteland-junk-156",
      kind: "prop",
      label: "Barrel",
      position: { x: -14.479, z: -23.646 },
      size: { w: 0.627, d: 0.627, h: 0.841 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.775,
    },
    {
      id: "deep_wasteland-junk-157",
      kind: "prop",
      label: "Sandbags",
      position: { x: 17.921, z: 28.793 },
      size: { w: 1.587, d: 0.23, h: 0.216 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 3.44,
    },
    {
      id: "deep_wasteland-junk-158",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 6.55, z: -17.063 },
      size: { w: 0.668, d: 0.843, h: 0.959 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 3.2,
    },
    {
      id: "deep_wasteland-junk-159",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 14.001, z: 0.239 },
      size: { w: 0.638, d: 0.806, h: 0.917 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 2.486,
    },
    {
      id: "deep_wasteland-junk-160",
      kind: "prop",
      label: "Utility Post",
      position: { x: -13.522, z: 15.643 },
      size: { w: 1.298, d: 1.805, h: 3.768 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 0.68,
    },
    {
      id: "deep_wasteland-junk-161",
      kind: "prop",
      label: "Sandbags",
      position: { x: -0.62, z: 8.679 },
      size: { w: 1.488, d: 0.216, h: 0.203 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 5.405,
    },
    {
      id: "deep_wasteland-junk-162",
      kind: "prop",
      label: "Tarp",
      position: { x: 13.254, z: 1.793 },
      size: { w: 1.521, d: 1.308, h: 0.451 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 4.93,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-163",
      kind: "prop",
      label: "Tarp",
      position: { x: -29.651, z: -5.073 },
      size: { w: 1.251, d: 1.076, h: 0.371 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 5.672,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-164",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -3.737, z: -8.983 },
      size: { w: 2.234, d: 2.018, h: 0.946 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 0.125,
    },
    {
      id: "deep_wasteland-junk-165",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -16.84, z: -7.839 },
      size: { w: 1.776, d: 1.604, h: 0.752 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 2.595,
    },
    {
      id: "deep_wasteland-junk-166",
      kind: "prop",
      label: "Stump",
      position: { x: -11.585, z: -27.373 },
      size: { w: 0.821, d: 0.801, h: 0.899 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 5.095,
    },
    {
      id: "deep_wasteland-junk-167",
      kind: "prop",
      label: "Tarp",
      position: { x: -21.697, z: 24.123 },
      size: { w: 1.499, d: 1.289, h: 0.445 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 4.347,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-168",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 6.55, z: -23.96 },
      size: { w: 2.011, d: 1.817, h: 0.852 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 5.976,
    },
    {
      id: "deep_wasteland-junk-169",
      kind: "prop",
      label: "Broken Tree",
      position: { x: 31.912, z: 16.813 },
      size: { w: 4.745, d: 2.817, h: 2.872 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      rotationY: 0.319,
    },
    {
      id: "deep_wasteland-junk-170",
      kind: "prop",
      label: "Stump",
      position: { x: -13.071, z: 20.852 },
      size: { w: 0.685, d: 0.669, h: 0.751 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 3.462,
    },
    {
      id: "deep_wasteland-junk-171",
      kind: "prop",
      label: "Utility Post",
      position: { x: -29.406, z: -14.124 },
      size: { w: 1.234, d: 1.716, h: 3.581 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 3.442,
    },
    {
      id: "deep_wasteland-junk-172",
      kind: "prop",
      label: "Stump",
      position: { x: -36.128, z: -2.732 },
      size: { w: 0.613, d: 0.598, h: 0.671 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 6.202,
    },
    {
      id: "deep_wasteland-junk-173",
      kind: "prop",
      label: "Barrel",
      position: { x: -33.169, z: 14.862 },
      size: { w: 0.662, d: 0.662, h: 0.888 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.453,
    },
    {
      id: "deep_wasteland-junk-174",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -15.246, z: 29.513 },
      size: { w: 0.791, d: 0.998, h: 1.136 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 2.702,
    },
    {
      id: "deep_wasteland-junk-175",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 13.037, z: -19.769 },
      size: { w: 2.206, d: 1.992, h: 0.934 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 3.34,
    },
    {
      id: "deep_wasteland-junk-176",
      kind: "prop",
      label: "Stump",
      position: { x: 7.045, z: -19.021 },
      size: { w: 0.813, d: 0.793, h: 0.891 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 1.823,
    },
    {
      id: "deep_wasteland-junk-177",
      kind: "prop",
      label: "Stump",
      position: { x: -10.004, z: 12.293 },
      size: { w: 0.727, d: 0.709, h: 0.796 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 5.791,
    },
    {
      id: "deep_wasteland-junk-178",
      kind: "prop",
      label: "Stump",
      position: { x: -30.481, z: -17.59 },
      size: { w: 0.606, d: 0.591, h: 0.664 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 5.896,
    },
    {
      id: "deep_wasteland-junk-180",
      kind: "prop",
      label: "Barrel",
      position: { x: 8.182, z: 12.307 },
      size: { w: 0.794, d: 0.794, h: 1.066 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.817,
    },
    {
      id: "deep_wasteland-junk-181",
      kind: "prop",
      label: "Stump",
      position: { x: -4.915, z: 25.325 },
      size: { w: 0.754, d: 0.736, h: 0.826 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 5.363,
    },
    {
      id: "deep_wasteland-junk-182",
      kind: "prop",
      label: "Tarp",
      position: { x: 7.039, z: -11.778 },
      size: { w: 1.16, d: 0.998, h: 0.344 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 4.88,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-183",
      kind: "prop",
      label: "Tarp",
      position: { x: 24.877, z: 13.539 },
      size: { w: 1.282, d: 1.102, h: 0.38 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 3.845,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-184",
      kind: "prop",
      label: "Sandbags",
      position: { x: 5.668, z: 31.677 },
      size: { w: 1.644, d: 0.238, h: 0.224 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 6.242,
    },
    {
      id: "deep_wasteland-junk-185",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 27.152, z: 5.883 },
      size: { w: 0.628, d: 0.793, h: 0.902 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 2.521,
    },
    {
      id: "deep_wasteland-junk-186",
      kind: "prop",
      label: "Stump",
      position: { x: -0.831, z: 19.208 },
      size: { w: 0.653, d: 0.637, h: 0.715 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 2.925,
    },
    {
      id: "deep_wasteland-junk-187",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -14.442, z: 21.027 },
      size: { w: 2.052, d: 1.853, h: 0.869 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 2.343,
    },
    {
      id: "deep_wasteland-junk-188",
      kind: "prop",
      label: "Sandbags",
      position: { x: 1.152, z: 12.15 },
      size: { w: 1.995, d: 0.289, h: 0.272 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 2.491,
    },
    {
      id: "deep_wasteland-junk-189",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -17.025, z: 2.754 },
      size: { w: 0.78, d: 0.985, h: 1.121 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 6.081,
    },
    {
      id: "deep_wasteland-junk-190",
      kind: "prop",
      label: "Tarp",
      position: { x: 2.514, z: -23.456 },
      size: { w: 1.457, d: 1.253, h: 0.432 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 4.789,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-191",
      kind: "prop",
      label: "Sandbags",
      position: { x: -16.874, z: 19.135 },
      size: { w: 1.829, d: 0.265, h: 0.249 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 6.158,
    },
    {
      id: "deep_wasteland-junk-192",
      kind: "prop",
      label: "Barrel",
      position: { x: 0.315, z: -7.544 },
      size: { w: 0.743, d: 0.743, h: 0.998 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.052,
    },
    {
      id: "deep_wasteland-junk-193",
      kind: "prop",
      label: "Barrel",
      position: { x: -23.289, z: -4.701 },
      size: { w: 0.768, d: 0.768, h: 1.031 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.011,
    },
    {
      id: "deep_wasteland-junk-194",
      kind: "prop",
      label: "Stump",
      position: { x: -17.387, z: -27.68 },
      size: { w: 0.75, d: 0.732, h: 0.821 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 4.457,
    },
    {
      id: "deep_wasteland-junk-195",
      kind: "prop",
      label: "Tarp",
      position: { x: 8.199, z: -29.79 },
      size: { w: 1.194, d: 1.027, h: 0.354 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 4.216,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-196",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -16.302, z: -32.193 },
      size: { w: 2.353, d: 2.126, h: 0.997 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 0.946,
    },
    {
      id: "deep_wasteland-junk-197",
      kind: "prop",
      label: "Barrel",
      position: { x: -33.053, z: -9.726 },
      size: { w: 0.807, d: 0.807, h: 1.084 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.242,
    },
    {
      id: "deep_wasteland-junk-198",
      kind: "prop",
      label: "Utility Post",
      position: { x: -22.816, z: 26.994 },
      size: { w: 1.592, d: 2.215, h: 4.621 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 5.432,
    },
    {
      id: "deep_wasteland-junk-199",
      kind: "prop",
      label: "Stump",
      position: { x: -1.789, z: 26.051 },
      size: { w: 0.617, d: 0.602, h: 0.676 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 0.077,
    },
    {
      id: "deep_wasteland-junk-200",
      kind: "prop",
      label: "Barrel",
      position: { x: -18.339, z: -17.392 },
      size: { w: 0.718, d: 0.718, h: 0.963 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.9,
    },
    {
      id: "deep_wasteland-junk-201",
      kind: "prop",
      label: "Barrel",
      position: { x: -14.626, z: -21.843 },
      size: { w: 0.763, d: 0.763, h: 1.024 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 6.11,
    },
    {
      id: "deep_wasteland-junk-203",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 34.118, z: 2.199 },
      size: { w: 0.813, d: 1.026, h: 1.168 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 3.99,
    },
    {
      id: "deep_wasteland-junk-204",
      kind: "prop",
      label: "Tarp",
      position: { x: -13.892, z: 28.04 },
      size: { w: 1.175, d: 1.01, h: 0.349 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 5.121,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "deep_wasteland-junk-205",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -22.051, z: -25.982 },
      size: { w: 2.432, d: 2.196, h: 1.03 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 2.65,
    },
    {
      id: "deep_wasteland-junk-206",
      kind: "prop",
      label: "Barrel",
      position: { x: 9.754, z: -28.314 },
      size: { w: 0.733, d: 0.733, h: 0.984 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.286,
    },
    {
      id: "deep_wasteland-junk-207",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -17.128, z: 22.46 },
      size: { w: 1.746, d: 1.577, h: 0.74 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 4.754,
    },
    {
      id: "deep_wasteland-junk-208",
      kind: "prop",
      label: "Sandbags",
      position: { x: -31.832, z: -10.619 },
      size: { w: 1.591, d: 0.231, h: 0.217 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 4.251,
    },
    {
      id: "deep_wasteland-junk-209",
      kind: "prop",
      label: "Barrel",
      position: { x: 32.305, z: -11.179 },
      size: { w: 0.584, d: 0.584, h: 0.784 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.046,
    },
    {
      id: "deep_wasteland-junk-210",
      kind: "prop",
      label: "Wire Fence",
      position: { x: 3.569, z: 13.855 },
      size: { w: 2.144, d: 0.107, h: 2.048 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 3.675,
    },
    {
      id: "deep_wasteland-junk-211",
      kind: "prop",
      label: "Barrel",
      position: { x: -6.471, z: -35.371 },
      size: { w: 0.806, d: 0.806, h: 1.082 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.772,
    },
    {
      id: "deep_wasteland-junk-212",
      kind: "prop",
      label: "Stump",
      position: { x: 6.907, z: 13.517 },
      size: { w: 0.642, d: 0.627, h: 0.703 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 1.113,
    },
    {
      id: "deep_wasteland-junk-213",
      kind: "prop",
      label: "Sandbags",
      position: { x: 21.141, z: -4.56 },
      size: { w: 1.558, d: 0.226, h: 0.212 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 0.045,
    },
    {
      id: "deep_wasteland-junk-214",
      kind: "prop",
      label: "Stump",
      position: { x: -18.792, z: -25.342 },
      size: { w: 0.643, d: 0.627, h: 0.704 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 0.264,
    },
    {
      id: "deep_wasteland-junk-215",
      kind: "prop",
      label: "Wire Fence",
      position: { x: 8.88, z: 30.767 },
      size: { w: 2.258, d: 0.113, h: 2.157 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 3.135,
    },
    {
      id: "deep_wasteland-junk-216",
      kind: "prop",
      label: "Barrel",
      position: { x: 33.207, z: -6.756 },
      size: { w: 0.798, d: 0.798, h: 1.071 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.464,
    },
    {
      id: "deep_wasteland-junk-217",
      kind: "prop",
      label: "Barrel",
      position: { x: 8.579, z: -28.284 },
      size: { w: 0.757, d: 0.757, h: 1.016 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.728,
    },
    {
      id: "deep_wasteland-junk-218",
      kind: "prop",
      label: "Barrel",
      position: { x: 2.441, z: -33.083 },
      size: { w: 0.695, d: 0.695, h: 0.933 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.755,
    },
    {
      id: "deep_wasteland-junk-219",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 13.795, z: 27.736 },
      size: { w: 2.181, d: 1.97, h: 0.924 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 4.995,
    },
    {
      id: "deep_wasteland-junk-221",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 2.23, z: -19.262 },
      size: { w: 2.083, d: 1.881, h: 0.882 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 0.093,
    },
    {
      id: "deep_wasteland-junk-222",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 4.354, z: 17.037 },
      size: { w: 1.838, d: 1.66, h: 0.778 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 6.239,
    },
    {
      id: "deep_wasteland-junk-223",
      kind: "prop",
      label: "Sandbags",
      position: { x: -34.249, z: 13.693 },
      size: { w: 1.921, d: 0.279, h: 0.262 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 3.603,
    },
    {
      id: "deep_wasteland-junk-224",
      kind: "prop",
      label: "Barrel",
      position: { x: 18.685, z: -23.387 },
      size: { w: 0.746, d: 0.746, h: 1.002 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.276,
    },
    {
      id: "deep_wasteland-junk-225",
      kind: "prop",
      label: "Stump",
      position: { x: 15.728, z: 27.169 },
      size: { w: 0.802, d: 0.782, h: 0.878 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 4.03,
    },
    {
      id: "deep_wasteland-junk-226",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 2.745, z: -11.41 },
      size: { w: 0.738, d: 0.931, h: 1.06 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 3.855,
    },
    {
      id: "deep_wasteland-junk-227",
      kind: "prop",
      label: "Barrel",
      position: { x: -15.973, z: -15.809 },
      size: { w: 0.815, d: 0.815, h: 1.094 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.194,
    },
    {
      id: "deep_wasteland-junk-228",
      kind: "prop",
      label: "Barrel",
      position: { x: 33.677, z: 9.681 },
      size: { w: 0.582, d: 0.582, h: 0.781 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.43,
    },
    {
      id: "deep_wasteland-junk-229",
      kind: "prop",
      label: "Stump",
      position: { x: 34.612, z: -3.74 },
      size: { w: 0.697, d: 0.68, h: 0.763 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 2.768,
    },
    {
      id: "deep_wasteland-junk-230",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -13.269, z: 17.446 },
      size: { w: 0.733, d: 0.925, h: 1.053 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 2.889,
    },
  ],

  collisionZones: [
    {
      id: "edge-n",
      label: "Ridge",
      position: { x: 0, z: -41 },
      size: { w: 84, d: 2 },
    },
    {
      id: "edge-s",
      label: "Ridge",
      position: { x: 0, z: 41 },
      size: { w: 84, d: 2 },
    },
    {
      id: "edge-w",
      label: "Ridge",
      position: { x: -41, z: 0 },
      size: { w: 2, d: 84 },
    },
    {
      id: "edge-e",
      label: "Ridge",
      position: { x: 41, z: 0 },
      size: { w: 2, d: 84 },
    },
    {
      id: "fog-1",
      label: "Low Fog",
      position: { x: -18.22, z: 6.87 },
      size: { w: 17.346918430179358, d: 14.644307537004352 },
      blocksVision: true,
      blocksMovement: false,
      fog: { color: 10129272, opacity: 0.35, height: 4 },
    },
    {
      id: "fog-2",
      label: "Low Fog",
      position: { x: 21.68, z: -28.13 },
      size: { w: 17.92550203576684, d: 16.72908341512084 },
      blocksVision: true,
      blocksMovement: false,
      fog: { color: 10129272, opacity: 0.35, height: 4 },
    },
    {
      id: "fog-3",
      label: "Low Fog",
      position: { x: 25.77, z: 18.06 },
      size: { w: 21.071583423763514, d: 13.353204878047109 },
      blocksVision: true,
      blocksMovement: false,
      fog: { color: 10129272, opacity: 0.35, height: 4 },
    },
  ],

  roads: [
    {
      id: "dw-highway",
      label: "Old Highway",
      surface: "dirt_road",
      points: [{ x: -38, z: 30 }, { x: 36, z: -30 }],
      width: 4.92,
      opacity: 0.6,
    },
    {
      id: "dw-trail",
      label: "Scav Trail",
      surface: "dirt_path",
      points: [{ x: -34, z: -26 }, { x: 34, z: 26 }],
      width: 3.608,
      opacity: 0.6,
    },
  ],

  npcs: {
  },

  dialog: {
  },
};
